import { render, staticRenderFns } from "./duediligencestatement.vue?vue&type=template&id=33385da1"
import script from "./duediligencestatement.vue?vue&type=script&lang=js"
export * from "./duediligencestatement.vue?vue&type=script&lang=js"
import style0 from "./duediligencestatement.vue?vue&type=style&index=0&id=33385da1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports